import {
  AssetLogo,
  isSvgIconName,
  LogoTypes,
  SvgIconNames,
  Toggle,
} from '@toggle/design-system';
import { getAssetLogoFromEntity } from '@toggle/toggle';
import React from 'react';

import { ChartEntity } from '~/types/timeseries.types';

import * as S from './ChartTypeSelectorItem.style';

export interface ChartTypeSelectorItemProps {
  entity: ChartEntity;
  isChecked: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const ChartTypeSelectorItem = ({
  entity,
  isChecked,
  onClick,
  disabled = false,
}: ChartTypeSelectorItemProps) => {
  const {
    entity: mappedEntity,
    variant,
    isNotStockEntity,
    isFiEntity,
    iconName,
    subClassIcon,
  } = getAssetLogoFromEntity(entity);
  const type = variant ? LogoTypes[variant] : undefined;
  const safeIconName: SvgIconNames = isSvgIconName(iconName)
    ? iconName
    : 'ChartLine';
  const safeSubClassIcon: SvgIconNames = isSvgIconName(subClassIcon)
    ? subClassIcon
    : 'ChartLine';

  return (
    <S.Wrapper>
      <S.AssetWrapper>
        <AssetLogo
          type={type}
          isNotStockEntity={isNotStockEntity}
          isFiEntity={isFiEntity}
          placeholderIconName={safeIconName}
          placeholderSubClassIcon={safeSubClassIcon}
          entity={mappedEntity}
          size={20}
          logoUrl={entity.logo_urls.light_png}
        />
        <S.AssetTicker>{entity.formattedTicker}</S.AssetTicker>
      </S.AssetWrapper>
      <Toggle
        data-testid={`${entity.formattedTicker}toggle`}
        isChecked={isChecked}
        onClick={onClick}
        disabled={disabled}
      />
    </S.Wrapper>
  );
};
